import React from 'react';
import { OccurrenceDetail } from '../../components/occurrence/OccurrenceDetail';
import { EventsParamList } from '../../typings/Params';
import { RouteProp, useRoute } from '@react-navigation/native';
import { RootNavigation } from '../../Routes';


interface EventsOccurrenceDetailParams {
    navigation: RootNavigation;
}

export default function EventsOccurrenceDetail({ navigation }: EventsOccurrenceDetailParams) {
    const route = useRoute<RouteProp<EventsParamList, 'EventsOccurrenceDetail'>>();
    return (
        <OccurrenceDetail navigation={navigation} occurrenceId={route.params.occurrenceId} page={'events'} />
    );
}
